import { Card, CardContent } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  root: {
    
    "@media (max-width: 400px)": {
      width:'260px',
      height:'160px',
      flexDirection:"column"
    },
    "@media (min-width: 600px)": {
    minWidth: 370,
    },
    margin: 10,
    padding: 10,
    boxShadow: "0px 4px 30px #FBEAFF",
    height: '100px',
    fontSize: '20px',
    fontWeight: '500'
  },
});

export default function Valuecard(props) {
  const classes = useStyles();

  return (
    <Card className={classes.root} >
      <CardContent >
        {props.text}
      </CardContent >
    </Card >
  );
}
